import {
    useMemo,
} from 'react'
import StatusHandler from 'app/shared-components/StatusHandler'
import requests from 'app/requests/FreightForwarder.request'
import useGetFreightForwarder from 'app/Apps/OrderManagement/hooks/useGetFreightForwarder'

import {
    ArchiveButton, ArchiveConfirmationDialog,
    useArchive,
} from 'app/shared-components/Archive'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import FreightForwarderForm from '../FreightForwarderForm'

const FreightForwarderUpdate = ({
    id,
    disabled = false,
}: Readonly<{
    id: number,
    disabled?: boolean
}>) => {
    const {
        FreightForwarders: FreightForwardersRoutes,
    } = useOrderManagementRoutes()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetFreightForwarder(id)

    const archive = useArchive({
        requestParamFn: data?.archived ? requests.restore
            : requests.archive,
        notificationId: 'FreightForwarder',
        title: 'Freight Forwarder',
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: FreightForwardersRoutes.Overview.path,
            params: {
                key: id,
            },
        }),
        onSuccess: invalidate,
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        data,
        archive.handleArchiveRestore,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <FreightForwarderForm
                    onSuccess={invalidate}
                    onCancel={invalidate}
                    customButtons={customButtons}
                    data={data}
                    disabled={disabled}
                    request={requests.update({
                        id,
                    })}
                />
                <ArchiveConfirmationDialog
                    title="Freight Forwarder"
                    openConfirmDialog={archive.openConfirmDialog}
                    handleClose={archive.handleArchiveRestoreConfirm}
                    archived={data?.archived}
                />
            </>
        </StatusHandler>
    )
}

export default FreightForwarderUpdate
